export default {
  loading: state => {
    return state.loading
  },
  attachments: state => {
    return state.attachments;
  }
}
